import {createAction, props} from '@ngrx/store';
import {EkranPodsumowaniaActionType} from '../ekran-podsumowania-action-type';
import {Samoobsluga} from '../../../../../../../shared/services/samoobsluga/types/samoobsluga';

export const pominEkranRoszczenIPrzekierujWZaleznosciOdKwotyDocelowej = createAction(
  EkranPodsumowaniaActionType.POMIN_EKRAN_ROSZCZEN, props<Samoobsluga>()
);

export const pominEkranRoszczenIPrzekierujNaEkranBrakuPrezentacjiKwoty = createAction(
  EkranPodsumowaniaActionType.POMIN_EKRAN_ROSZCZEN_EKRAN_BRAKU_PREZENTACJI_KWOTY, props<Samoobsluga>()
);

export const pominEkranRoszczenZUzupelnionymRoszczeniem = createAction(
  EkranPodsumowaniaActionType.POMIN_EKRAN_ROSZCZEN_ROSZCZENIE_Z_UZUPELNIONYM_ROSZCZENIEM
);
